<template lang="pug">
div.wrapper(@click="onClick" :style="{ width: canvasWidth + 'px' , height:canvasHeight + 'px' } ")
  canvas.cc(ref="tiles"  :width="canvasWidth" :height="canvasHeight" )
  canvas.cc(ref="focus"  :width="canvasWidth" :height="canvasHeight" )
</template>

<script>
import CanvasMixin from "./CanvasMixin"
import CanvasGen from "@/canvas"
let padding = 10

let pieces = [
  ["em", "lh", "lv"],
  ["sl", "tl", "tr"],
  ["dt", "bl", "br"],
  ["dr", "jh", "jv"],
  ["db", "cr", "bb"],
  ["dl", "tul", "tur"],
  ["ibr", "itr"],
  ["ibl", "itl"]
]
let ctx = null
let fc = null
export default {
  name: "BuildDeck",
  components: {},
  mixins: [CanvasMixin],
  props: {
    active: { type: String }
  },
  data() {
    let tile = this.$state.scale * this.$tileSize + padding

    return {
      canvasWidth: tile * 3,
      canvasHeight: tile * pieces.length,
      lock: false,
      board: [],
      currentX: null,
      currentY: null
    }
  },
  created() {
    this.canvasTiles = CanvasGen(this.$state.scale, this.$state.scale * this.$tileSize, this.$state.scale * this.$dropSize, this.$state.color)
  },
  mounted() {
    this.$nextTick(() => {
      this.InitializeCanvas()
    })
    this.$emit("update:active", "em")
  },
  methods: {
    InitializeCanvas() {
      ctx = this.$refs.tiles.getContext("2d")
      ctx.translate(1, 1)

      fc = this.$refs.focus.getContext("2d")

      fc.strokeStyle = "red"
      this.drawPieces()
    },
    drawActive({ item, x, y }) {
      fc.clearRect(0, 0, fc.canvas.width, fc.canvas.height)
      let sz = this.scaledTile + padding
      let w = this.scaledTile
      let h = this.scaledTile
      let _x = x
      let _y = y
      if (item == "tur") {
        w *= 2
        _x--
      } else if (item == "tul") {
        w *= 2
      } else if (item == "itr") {
        _x--
        h *= 2
        w *= 2
      } else if (item == "ibl") {
        _y--
        h *= 2
        w *= 2
      } else if (item == "itl") {
        _x--
        _y--
        h *= 2
        w *= 2
      } else if (item == "ibr") {
        h *= 2
        w *= 2
      }

      //console.log("drawActive", { item, x, y, _x, _y, h, w })

      fc.strokeRect(_x * sz + 1, _y * sz + 1, w, h)
    },
    drawPieces() {
      let sz = this.scaledTile + padding

      for (let y = 0; y < pieces.length; y++) {
        for (let x = 0; x < 3; x++) {
          let p = pieces[y][x]
          if (["itr", "ibl", "itl", "tur"].includes(p)) continue
          if (p == null) continue
          let _c = this.canvasTiles[p]
          //console.log(p, _c)
          ctx.drawImage(_c, x * sz, y * sz)
        }
      }

      this.drawActive({ x: 0, y: 0 })
    },
    async onClick({ offsetX, offsetY }) {
      //console.log("onClick -- builder", this.lock)
      if (this.lock) return

      let size = this.scaledTile + padding

      let x = Math.floor(offsetX / size)
      let y = Math.floor(offsetY / size)

      let item = pieces[y][x]

      this.drawActive({ item, x, y })

      if (["ibl", "itl", "itr"].includes(item)) item = "ibr"
      else if (item == "tur") item = "tul"

      this.lock = true

      this.$emit("update:active", item)

      setTimeout(() => (this.lock = false), 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  position: relative;
  padding-right: 10px;
  .cc {
    position: absolute;
    top: 0;
  }
}
</style>
